import { type PropsWithChildren } from "react";
import { Box } from "@ecco/ui/box";

type MainWrapperProps = PropsWithChildren;

export function MainWrapper({ children, ...rest }: MainWrapperProps) {
    return (
        <Box as="main" minBlockSize="100vh" {...rest}>
            {children}
        </Box>
    );
}
